import { createContext, useContext, useState, useEffect } from "react";
import { registerLogout } from "../services/authService";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
	const [token, setToken] = useState(() => localStorage.getItem("authToken"));

	const login = (newToken) => {
		localStorage.setItem("authToken", newToken);
		setToken(newToken);
	};

	const logout = () => {
		localStorage.removeItem("authToken");
		setToken(null);
	};

	useEffect(() => {
		registerLogout(logout);
	}, []);

	return (
		<AuthContext.Provider value={{ token, login, logout }}>
			{children}
		</AuthContext.Provider>
	);
};

export const useAuth = () => useContext(AuthContext);
